import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { hasRole } from "../../constants/roles";

export function RequireRole({ roles }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center bg-slate-50 text-sm text-slate-500">
        Checking your access…
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = `${location.pathname}${location.search}${location.hash}`;
    return (
      <Navigate
        to={`/login?redirect=${encodeURIComponent(redirectTo)}`}
        replace
        state={{ from: location }}
      />
    );
  }

  if (!hasRole(user?.role, roles)) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
